import { gql } from '@apollo/client'

export const SIMPLE_FLAGGABLE_OBJECT_FRAGMENT = gql`
  fragment SimpleFlaggableObject on FlaggableObject {
    flagged {
      level
      reason
      reasonType
      moreInfo
      flaggedBy {
        uuid
        id
        email
        firstName
        lastName
      }
      levelRaisedBy {
        uuid
        id
        email
        firstName
        lastName
        username
      }
      date
    }
    ... on DisplayAuditImage {
      id
      url
    }
    ... on Product {
      upcA
    }
  }
`
